export default "__VITE_ASSET__EZDgo_T9__"